import WrapperService from "@/modules/core/services/wrapper-service";

const API_URL = process.env.VUE_APP_ROOT_API + "/api/v1/country"

const serviceName = "Country-Service: ";

export default class CountryService {

  static async readAllFromAPI(successF, errorF) {
    await WrapperService.get(API_URL, null, serviceName, successF, errorF);
  }

  static async readFromAPI(id, successF, errorF) {
    await WrapperService.get(API_URL + "/" + id, null, serviceName, successF, errorF);
  }

  static async readProvincesOfCountry(countryID, successF, errorF) {
    await WrapperService.get(API_URL + "/" + countryID + "/province", null, serviceName, successF, errorF)
  }
}
